module.exports = __webpack_public_path__ + "media/images/icon_list/chevron_right-7a0a747044059f9695f90f12f58aa4ae.svg";